module.exports = __webpack_public_path__ + "img/15.f9c4a2cd.jpg";